import { useState } from 'react';
import { generateMockResponse } from '../utils/mockAI';

export function useCheckIn() {
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState([]);
  const [formData, setFormData] = useState({
    mood: '',
    stress: 5,
    thoughts: '',
    date: new Date().toISOString().split('T')[0],
  });

  const submitCheckIn = async (data) => {
    setLoading(true);
    
    // Simulate API call delay
    setTimeout(() => {
      const mockResponse = generateMockResponse(data.mood, data.stress, data.thoughts);
      
      // Set response
      setResponse(mockResponse);
      
      // Add to history
      setHistory([
        {
          mood: data.mood,
          stress: data.stress,
          thoughts: data.thoughts,
          timestamp: new Date().toLocaleTimeString(),
          date: data.date,
        },
        ...history,
      ]);
      
      // Clear form
      setFormData({
        mood: '',
        stress: 5,
        thoughts: '',
        date: new Date().toISOString().split('T')[0],
      });
      
      setLoading(false);
    }, 800);
  };

  const updateFormData = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value,
    }));
  };

  const reset = () => {
    setResponse(null);
    setFormData({
      mood: '',
      stress: 5,
      thoughts: '',
      date: new Date().toISOString().split('T')[0],
    });
  };

  return {
    response,
    loading,
    history,
    formData,
    submitCheckIn,
    updateFormData,
    reset,
  };
}
